import React from "react";
import * as Yup from "yup";
import { Formik, Form } from "formik";

import { useAppDispatch } from "../../../../redux/store";
import { useSelector } from "react-redux";
import { fetchSendCode, fetchSendPhone } from "../../../../redux/profile/settings/changePass/asyncActions";
import { changePassSelector } from "../../../../redux/profile/settings/changePass/selectors";
import { clearErrorMessage } from "../../../../redux/profile/settings/changePass/slice";

import styles from "./SmsCodeForm.module.scss";

import { SubmitValueType } from "./types";
import AuthCode from "react-auth-code-input";
import { useInterval } from "../../../../hooks/useInterval";
import { formatPhone } from "../../../../utils";
import { FormNames } from "../../../../resources/constants";
import { getSendCodeErrorMessage } from "../../../../helpers/sendCodeError";

type SmsCodeFormProps = {
  handleSubmitForm?: () => void;
};

export const SmsCodeForm: React.FC<SmsCodeFormProps> = (props) => {
  const { handleSubmitForm } = props;
  const { phone, errorMessage, isLoading } = useSelector(changePassSelector);
  const [resendError, setResendError] = React.useState<string>("");
  const [errorCode, setErrorCode] = React.useState(false);
  const [timer, setTimer] = React.useState(60);
  const dispatch = useAppDispatch();

  const initialValues = {
    code: [""],
  };

  const validationSchema = Yup.object({
    code: Yup.array().of(Yup.string().required("Required")),
  });

  const handleSubmit = async (values: SubmitValueType) => {
    const code = values.code.join("");
    setErrorCode(false);
    dispatch(clearErrorMessage());

    const data = {
      phone,
      code: Number(code),
    };

    try {
      const result = await dispatch(fetchSendCode(data)).unwrap();
      
      if (result && result.form === FormNames.PASSWORD) {
        handleSubmitForm && handleSubmitForm();
      }
    } catch (error: any) {
      setErrorCode(true);
      dispatch(clearErrorMessage());
    }
  };

  useInterval(() => {
    setTimer(timer - 1);
  }, timer > 0 ? 1000 : null);

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
      validateOnChange={false}
      validateOnBlur={false}
    >
      {(formik) => {
        return (
          <Form className={styles.form}>
            <p className={styles.description}>
              Код подтверждения отправлен на номер <br/> 
              <span className={styles.phone}>
                {formatPhone(phone)}
              </span>
            </p>

            <div className={styles.formSection}>
              <div className={styles.inputsWrapper}>
                <AuthCode
                  containerClassName={styles.inputsWrapper}
                  length={4}
                  inputClassName={`${styles.input} ${errorCode ? styles.input_error : ''}`}
                  allowedCharacters='numeric'
                  autoFocus
                  onChange={(v) => {
                    formik.setValues({ code: [v] });

                    if (v.length === 4) {
                      formik.handleSubmit();
                    }
                  }}
                />
              </div>
              {errorCode && !errorMessage ? (
                  <div className={`${styles.errorMessage}`}>
                    Неверный код подтверждения
                  </div>
                ) : null}
              {resendError ? (
                  <div className={`${styles.errorMessage}`}>{resendError}</div>
                ) : null}
            </div>

            <div className={styles.description}>
              {timer !== 0 ? (
                <span className={styles.timer}>
                  Отправить повторно через {' '}
                  <span className={styles.timer_time}>
                    {timer} сек.
                  </span>
                </span>
              ) : (
                <span
                  className={styles.resend}
                  onClick={async () => {
                    dispatch(clearErrorMessage());
                    setErrorCode(false)
                    setResendError("");
                    try {
                      await dispatch(fetchSendPhone({ phone })).unwrap();
                      setTimer(60);
                    } catch (error) {
                      setResendError(getSendCodeErrorMessage(error));
                    }
                  }}
                >
                  Отправить код повторно
                </span>
              )}
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};
